import React from "react";

const DescriptionBox = () => {
  return (
    <div className="mx-[170px] my-[120px] max-[1280px]:mx-[60px] max-[800px]:mx-5">
      <div className="flex">
        <div className="flex items-center justify-center text-sm font-semibold w-[171px] h-[70px] border border-[rgba(0,212,255,0.4)] text-[#00d4ff] bg-[rgba(0,212,255,0.08)] cursor-pointer">Description</div>
        <div className="flex items-center justify-center text-sm font-semibold w-[171px] h-[70px] border border-white/[0.08] bg-white/[0.03] text-[#6b7a8d] cursor-pointer hover:text-[#a0aec0] transition-colors">Reviews (122)</div>
      </div>
      <div className="flex flex-col gap-6 border border-white/[0.08] bg-white/[0.02] p-12 pb-[70px] text-sm leading-relaxed text-[#a0aec0] max-[800px]:p-6">
        <p>
          An e-commerce website is an online platform that facilitates the
          buying and selling of products or services over the internet. It
          serves as a virtual marketplace where businesses and individuals can
          showcase their products, interact with customers, and conduct
          transactions without the need for a physical presence. E-commerce
          websites have gained immense popularity due to their convenience,
          accessibility, and the global reach they offer.
        </p>
        <p>
          E-commerce websites typically display products or services along with
          detailed descriptions, images, prices, and any available variations
          (e.g., sizes, colors). Each product usually has its own dedicated page
          with relevant information.
        </p>
      </div>
    </div>
  );
};

export default DescriptionBox;
